import React from 'react'
import { Zap, Gift, DollarSign, TrendingUp, Activity, ArrowUpRight, BarChart3 } from 'lucide-react'
import { useLanguage } from '../i18n'
import FuelPoolDashboard from '../components/FuelPoolDashboard'

const FuelPoolPage = ({ isConnected, userAddress }) => {
  const { t } = useLanguage()
  
  const fuelStats = [
    { icon: TrendingUp, value: '$128,450', label: t('fuel.totalRefund'), change: 22.5, changeLabel: t('fuel.thisMonth'), color: 'gold' },
    { icon: BarChart3, value: '1,247', label: t('fuel.refundUsers'), change: 18.3, changeLabel: t('fuel.thisWeek'), color: 'blue' },
    { icon: Activity, value: '892', label: t('fuel.todayLottery'), change: 5.7, changeLabel: t('fuel.yesterday'), color: 'green' },
    { icon: DollarSign, value: '$2,847', label: t('fuel.todayWin'), change: 0, changeLabel: t('fuel.realtime'), color: 'cyan' }
  ]

  const features = [
    {
      icon: Zap,
      title: t('fuel.gasAutoRefund'),
      description: t('fuel.gasAutoRefundDesc')
    },
    {
      icon: Gift,
      title: t('fuel.dailyLottery'),
      description: t('fuel.dailyLotteryDesc')
    },
    {
      icon: DollarSign,
      title: t('fuel.usdtReward'),
      description: t('fuel.usdtRewardDesc')
    },
    {
      icon: TrendingUp,
      title: t('fuel.transparentAllocation'),
      description: t('fuel.transparentAllocationDesc')
    }
  ]

  return (
    <div className="min-h-screen py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* 页面标题 */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center space-x-2 bg-titanium-gold/10 border border-titanium-gold/30 rounded-full px-4 py-2 mb-6">
            <Zap className="w-4 h-4 text-titanium-gold" />
            <span className="text-sm font-semibold text-titanium-gold uppercase tracking-wider">{t('fuel.fuelSystem')}</span>
          </div>
          <h1 className="tech-title text-5xl md:text-6xl font-bold mb-4">
            {t('fuel.title')}
          </h1>
          <p className="tech-subtitle text-xl max-w-3xl mx-auto">
            {t('fuel.subtitle')}
          </p>
        </div>

        {/* 燃料池统计 */}
        <div className="mb-12">
          <div className="tech-grid tech-grid-4">
            {fuelStats.map((stat, idx) => (
              <div key={idx} className="stat-card">
                <div className="flex items-start justify-between">
                  <div className="flex-1">
                    <div className="stat-value">{stat.value}</div>
                    <div className="stat-label">{stat.label}</div>
                    {stat.change !== undefined && (
                      <div className={`stat-change ${stat.change >= 0 ? 'positive' : 'negative'}`}>
                        {stat.change >= 0 ? <ArrowUpRight className="w-4 h-4" /> : <ArrowUpRight className="w-4 h-4 rotate-180" />}
                        <span>{Math.abs(stat.change)}%</span>
                        {stat.changeLabel && <span className="ml-1 opacity-70">{stat.changeLabel}</span>}
                      </div>
                    )}
                  </div>
                  <div className="icon-tech">
                    <stat.icon className="w-7 h-7" />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* 功能特性 */}
        <div className="mb-12">
          <div className="text-center mb-8">
            <h2 className="tech-title text-3xl font-bold mb-3">{t('fuel.coreAdvantages')}</h2>
            <p className="tech-subtitle text-lg">{t('fuel.coreAdvantagesDesc')}</p>
          </div>
          <div className="tech-grid tech-grid-2">
            {features.map((feature, idx) => (
              <div key={idx} className="glass-card p-8">
                <div className="icon-tech mb-6">
                  <feature.icon className="w-8 h-8" />
                </div>
                <h3 className="tech-title text-xl font-bold mb-3">{feature.title}</h3>
                <p className="tech-subtitle">{feature.description}</p>
              </div>
            ))}
          </div>
        </div>

        {/* 燃料池仪表盘 */}
        <div className="glass-card gold-border">
          <div className="p-8">
            <div className="text-center mb-8">
              <h2 className="tech-title text-3xl font-bold mb-3">{t('fuel.dashboard')}</h2>
              <p className="tech-subtitle text-lg">{t('fuel.dashboardDesc')}</p>
            </div>
            <FuelPoolDashboard
              isConnected={isConnected}
              walletAddress={userAddress}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default FuelPoolPage
